
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/benefits/shipping-leads",
      function () {
        return require("private-next-pages/benefits/shipping-leads/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/benefits/shipping-leads"])
      });
    }
  